<template>
    <div class="container-fluid">
        <div class="row">
            <DetailEquipment/>
            <QRcode/>
            <DetailEquipmentHistory/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRoute , useRouter } from 'vue-router';
const DetailEquipment = defineAsyncComponent(() => import("@/components/theme/ma/DetailEquipment.vue"))
const DetailEquipmentHistory = defineAsyncComponent(() => import("@/components/theme/ma/DetailEquipmentHistory.vue"))
const QRcode = defineAsyncComponent(() => import("@/components/theme/ma/QRcode.vue"))
</script>